import { render, staticRenderFns } from "./ServiceDocumentsPage.vue?vue&type=template&id=83149c1c"
import script from "./ServiceDocumentsPage.vue?vue&type=script&lang=js"
export * from "./ServiceDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./ServiceDocumentsPage.vue?vue&type=style&index=0&id=83149c1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports